import React from 'react';
import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import { fontHeading5 } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { getPlanIcon, PlanIconProps } from '../scripts/getPlanIcon';
import { OfferProps } from '../types';
import { AnimChangeChildren } from 'libs/growth-platform-brand-system-v2/src/utils/AnimChangeChildren';
import { Icon } from '@payfit/growth-platform-brand-system-v2/components/Picto/Icon';

const TitleContent = ({
  title,
  icon,
  index,
}: {
  title: string;
  icon: PlanIconProps['name'];
  index: number;
}) => {
  const _icon = getPlanIcon({ name: icon, index });

  return (
    <AnimChangeChildren>
      <div key={_icon} className={classNames('flex items-center gap-[12px]')}>
        {_icon && (
          <Icon name={_icon} className={classNames('h-[40px] w-[40px]')} />
        )}
        <h2 className={fontHeading5}>{title}</h2>
      </div>
    </AnimChangeChildren>
  );
};

export const Title = ({
  offer,
  index,
}: {
  offer: OfferProps;
  index: number;
}) => {
  return (
    <TitleContent title={offer.title || ''} icon={offer.icon} index={index} />
  );
};

export default Title;
